import { createSelector } from '@reduxjs/toolkit';

import { abnApi } from '../services/abn';
import type { RootState } from '../store';
import { isTruthyArray } from '../utils/isTruthyArray';

const selectExtraInfo = (state: RootState) => state.extraInfo;
const selectAbn = (state: RootState) => state.abn;

export const selectAllExtraInfo = createSelector(selectExtraInfo, selectAbn, (extraInfo, abn) => ({
  ...extraInfo,
  abn: abn.number,
  noAbn: abn.noAbn,
}));

export type AllExtraInfo = ReturnType<typeof selectAllExtraInfo>;

export const selectIsMoreBusinessDetailsValid = createSelector(
  selectExtraInfo,
  selectAbn,
  (extraInfo, abn) => {
    const moreBusinessDetailsCases = [
      isTruthyArray([
        abn.noAbn || abn.number,
        extraInfo.businessName,
        extraInfo.firstName,
        extraInfo.lastName,
        extraInfo.email,
        extraInfo.mobile,
        extraInfo.needInterestedParties,
      ]),
    ];

    if (extraInfo.needInterestedParties) {
      moreBusinessDetailsCases.push(extraInfo.interestedParties!.length > 0);
    }
    return moreBusinessDetailsCases.every((v) => v);
  }
);

export const selectIsCustomerHistoryValid = createSelector(selectExtraInfo, (extraInfo) => {
  const customerHistoryCases = [
    isTruthyArray([extraInfo.historyQuestions, extraInfo.claimCount, extraInfo.applied]),
  ];
  return customerHistoryCases.every((v) => v);
});

export const selectEnhancedExtraInfo = createSelector(
  selectExtraInfo,
  selectAbn,
  selectIsMoreBusinessDetailsValid,
  selectIsCustomerHistoryValid,
  (extraInfo, abn, isMoreBusinessDetailsValid, isCustomerHistoryValid) => ({
    ...extraInfo,
    abn: abn?.number,
    noAbn: abn?.noAbn,
    isMoreBusinessDetailsValid,
    isCustomerHistoryValid,
  })
);

export type EnhancedExtraInfo = ReturnType<typeof selectEnhancedExtraInfo>;

export const selectIndustry = (state: RootState) => state.businessDetails.industry;

abnApi.endpoints.abnLookup.select('abc');
